import React, { useState, useEffect } from 'react';
import Modal from './Modal'; // Menggunakan komponen Modal dasar kita
import './ImageViewerModal.css'; // CSS khusus untuk viewer ini

const ImageViewerModal = ({ show, onClose, images }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Reset index saat modal dibuka dengan gambar baru
  useEffect(() => {
    if (show) {
      setActiveIndex(0);
    }
  }, [show]);

  if (!show || !images || images.length === 0) {
    return null;
  }

  // Membuat URL lengkap untuk setiap gambar
  const imageUrls = images.map(img => `${process.env.REACT_APP_API_URL}/uploads/${img}`);

  // const goToPrev = (e) => {
  //   e.stopPropagation();
  //   setActiveIndex(activeIndex > 0 ? activeIndex - 1 : imageUrls.length - 1);
  // };

  // const goToNext = (e) => {
  //   e.stopPropagation();
  //   setActiveIndex(activeIndex < imageUrls.length - 1 ? activeIndex + 1 : 0);
  // };

  return (
    <Modal show={show} onClose={onClose} title={`Gambar (${activeIndex + 1} / ${imageUrls.length})`}>
      <div className="image-viewer">
        {/* {imageUrls.length > 1 && <button className="nav-btn prev" onClick={goToPrev}>&#10094;</button>} */}
        
        <div className="image-container">
            <img src={imageUrls[activeIndex]} alt={`Gambar ${activeIndex + 1}`} className="main-image" />
        </div>

        {/* {imageUrls.length > 1 && <button className="nav-btn next" onClick={goToNext}>&#10095;</button>} */}
        
        {imageUrls.length > 1 && (
            <div className="dots-container">
            {imageUrls.map((_, index) => (
                <div key={index} className={`dot ${activeIndex === index ? 'active' : ''}`} onClick={(e) => { e.stopPropagation(); setActiveIndex(index); }} />
            ))}
            </div>
        )}
      </div>
    </Modal>
  );
};

export default ImageViewerModal;